var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-bg",on:{"click":_vm.CLOSE_SHOW_THANKS_ACTION}},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"text",class:_vm.getTextColor},[_vm._v(_vm._s(_vm.getModalText))])])])}
var staticRenderFns = []

export { render, staticRenderFns }